<template>
	<div class="container"><slot></slot></div>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.container {
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
}
</style>
